export default {"src":"/_next/static/media/reviewStars.9bc1ed44.svg","height":64,"width":32,"blurWidth":0,"blurHeight":0};